/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_LabelInputs */

const en_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption File Name`)
};

const fr_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du fichier de sous-titres`)
};

const de_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname der Bildunterschrift`)
};

const it_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome file didascalia`)
};

const ru_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название файла субтитров`)
};

const es_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo de subtítulos`)
};

const zh_cn2_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题文件名`)
};

const ja_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションファイル名`)
};

const hi_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल नाम`)
};

const pt_pt2_ateliere_connect_caption_name_label = /** @type {(inputs: Ateliere_Connect_Caption_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo de legenda`)
};

/**
* | output |
* | --- |
* | "Caption File Name" |
*
* @param {Ateliere_Connect_Caption_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_label = /** @type {((inputs?: Ateliere_Connect_Caption_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_caption_name_label(inputs)
	if (locale === "de") return de_ateliere_connect_caption_name_label(inputs)
	if (locale === "it") return it_ateliere_connect_caption_name_label(inputs)
	if (locale === "ru") return ru_ateliere_connect_caption_name_label(inputs)
	if (locale === "es") return es_ateliere_connect_caption_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_caption_name_label(inputs)
	if (locale === "ja") return ja_ateliere_connect_caption_name_label(inputs)
	if (locale === "hi") return hi_ateliere_connect_caption_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_caption_name_label(inputs)
	return en_ateliere_connect_caption_name_label(inputs)
});